import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export class GetSiteSAMLConfigurationViewModelRequest extends Request<string, ISiteSAMLConfiguration> {
  constructor(idpConfigurationId: string) {
    super('getSiteSAMLConfiguration',  idpConfigurationId);
  }
}